import { render, staticRenderFns } from "./ArtistBoard.vue?vue&type=template&id=bb9352f8&scoped=true&"
import script from "./ArtistBoard.vue?vue&type=script&lang=js&"
export * from "./ArtistBoard.vue?vue&type=script&lang=js&"
import style0 from "./ArtistBoard.vue?vue&type=style&index=0&id=bb9352f8&scoped=true&lang=scss&"
import style1 from "./ArtistBoard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9352f8",
  null
  
)

export default component.exports